/**
 * 数据字典
 */
import * as Api from './api';

export default {
    data() {
        return {
            // 土地类型数据字典
            mixin_LandTypeDicList: [],
            mixin_LandTypeDic: {},
            // 土地状态数据字典
            mixin_LandStatusDicList: [],
            mixin_LandStatusDic: {},
            // 工程类型数据字典
            mixin_ProjectTypeDicList: [],
            mixin_ProjectTypeDic: {},
            // 监测点类型数据字典
            mixin_MonitorTypeDicList: [],
            mixin_MonitorTypeDic: {},
            // 水体分类数据字典
            mixin_WaterTypeDicList: [],
            mixin_WaterTypeDic: {},
            // 举报渠道数据字典
            mixin_ReportTypeDicList: [],
            mixin_ReportTypeDic: {},
        };
    },
    methods: {
        /**
         * 获取土地类型数据字典
         */
        mixinGetLandTypeDic() {
            Api.fethDic('dict_land_type')
                .run()
                .then((res) => {
                    let dic = {};
                    let data = res || [];
                    let result = [];
                    data.forEach((item) => {
                        let value = Number(item.vals);
                        let label = item.text;
                        let obj = {
                            label,
                            value,
                        };
                        result.push(obj);
                        dic[value] = label;
                    });
                    this.mixin_LandTypeDicList = result;
                    this.mixin_LandTypeDic = dic;
                });
        },
        /**
         * 获取土地类型数据字典
         */
        mixinGeLandStatusDic() {
            Api.fethDic('dict_land_status')
                .run()
                .then((res) => {
                    let dic = {};
                    let data = res || [];
                    let result = [];
                    data.forEach((item) => {
                        let value = Number(item.vals);
                        let label = item.text;
                        let obj = {
                            label,
                            value,
                        };
                        result.push(obj);
                        dic[value] = label;
                    });
                    this.mixin_LandStatusDicList = result;
                    this.mixin_LandStatusDic = dic;
                });
        },
        /**
         * 获取土地类型数据字典
         */
        mixinGetProjectTypeDic() {
            Api.fethDic('dict_project_type_first')
                .run()
                .then((res) => {
                    let dic = {};
                    let data = res || [];
                    let result = [];
                    data.forEach((item) => {
                        let value = item.vals;
                        let label = item.text;
                        let obj = {
                            label,
                            value,
                        };
                        result.push(obj);
                        dic[value] = label;
                    });
                    this.mixin_ProjectTypeDicList = result;
                    this.mixin_ProjectTypeDic = dic;
                });
        },
        /**
         * 获取监测点类型数据字典
         */
        mixinGetMonitorTypeDic() {
            Api.fethDic('dict_monitor_type')
                .run()
                .then((res) => {
                    let dic = {};
                    let data = res || [];
                    let result = [];
                    data.forEach((item) => {
                        let value = item.vals;
                        let label = item.text;
                        let obj = {
                            label,
                            value,
                        };
                        result.push(obj);
                        dic[value] = label;
                    });
                    this.mixin_MonitorTypeDicList = result;
                    this.mixin_MonitorTypeDic = dic;
                });
        },
        /**
         * 获取水体分类数据字典
         */
        mixinGetWaterTypeDic() {
            Api.fethDic('dict_water_type')
                .run()
                .then((res) => {
                    let dic = {};
                    let data = res || [];
                    let result = [];
                    data.forEach((item) => {
                        let value = Number(item.vals);
                        let label = item.text;
                        let obj = {
                            label,
                            value,
                        };
                        result.push(obj);
                        dic[value] = label;
                    });
                    this.mixin_WaterTypeDicList = result;
                    this.mixin_WaterTypeDic = dic;
                });
        },
        /**
         * 获取举报渠道数据字典
         */
        mixinGetReportTypeDic() {
            Api.fethDic('dict_complaint_way')
                .run()
                .then((res) => {
                    let dic = {};
                    let data = res || [];
                    let result = [];
                    data.forEach((item) => {
                        let value = item.vals;
                        let label = item.text;
                        let obj = {
                            label,
                            value,
                        };
                        result.push(obj);
                        dic[value] = label;
                    });
                    this.mixin_ReportTypeDicList = result;
                    this.mixin_ReportTypeDic = dic;
                });
        },
    },
};
